import Immutable from 'immutable';
import {createRepo} from '../services/repo';

const companiesRepo = createRepo({
  modelName: 'company',
  plural: 'companies',
  isGlobal: true,
  getCurrentCompanyId,
});

import {SET_CURRENT_COMPANY} from '../actions/companies';
import {LOGIN_SUCCESS} from '../actions/login';
const {COMPANIES_LOADING_SUCCESS, COMPANY_LOADING_SUCCESS} = companiesRepo.actions;
const {handleCompaniesLoading, handleCompanyLoading} = companiesRepo.reducers;

const initialState = companiesRepo.getInitialState({
  current: null,
});

export default function (state = initialState, action) {
  let index;

  switch (action.type) {
    case COMPANIES_LOADING_SUCCESS:
      return handleCompaniesLoading(state, action);
    case COMPANY_LOADING_SUCCESS:
      return handleCompanyLoading(state, action);
    case LOGIN_SUCCESS:
      if (!action.data.company) {
        return state;
      }

      const company = action.data.company;
      if (!company.id) {
        return state;
      }

      index = state.get('list').findIndex(c => c.get('id') === company.id);
      if (index > -1) {
        return state.setIn(['list', index], Immutable.fromJS(company)).set('current', company.id);
      }

      return state
        .set('list', state.get('list').push(Immutable.fromJS(company)))
        .set('current', company.id);
    default:
      return state;
  }
}

/* Selectors */

export const {getCompanies, getCompanyById, getCompaniesSelection} = companiesRepo.selectors;

export function getCurrentCompany(state) {
  return (
    getCompanies(state).find(
      company => company.get('id') === state.getIn(['companies', 'current'])
    ) || Immutable.Map()
  );
}

export function getCurrentCompanyId(state) {
  const company = getCurrentCompany(state);
  if (!company) {
    return null;
  }

  return company.get('id');
}
